import { combineReducers } from "redux";

const reducer = combineReducers({
  // Add your reducers here when you have them
  // For now, we'll add a placeholder to prevent the error
  app: (state = {}, action) => state
})

export default reducer;
